"use client";

import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterLuxon } from "@mui/x-date-pickers/AdapterLuxon";
import { ReactNode } from "react";

interface DateProviderProps {
    children: ReactNode;
}

export const DateProvider = ({ children }: DateProviderProps) => {
    return (
        <LocalizationProvider
            dateAdapter={AdapterLuxon}
            localeText={{
                cancelButtonLabel: "Відмінити",
                okButtonLabel: "Підтвердити",
                datePickerToolbarTitle: "Оберіть дату",
            }}
            adapterLocale="uk"
            dateFormats={{ keyboardDate: "dd.MM.yyyy" }}
        >
            {children}
        </LocalizationProvider>
    );
};
